import { getConfig } from '@klpkonsern/appconfig';
import { IconName } from '@klp/design/Illustrations';
import { SidebarMenuItem } from '@klp/layout/Sidebar/classes/SidebarMenuItem';
import { generateRoute } from '@klp/routing';

// Extend AppConfigParameters for this module
declare global {
    interface AppConfigParameters {
        WEBAPP_OPPSLAGSTAVLE_ENABLE: boolean;
        WEBAPP_MILJOPROFIL_ENABLE: boolean;
        WEBAPP_APP_SUSTAINABILITY_LINK: string;
        WEBAPP_APP_MILJOPROFIL_LINK: string;
    }
}

export const SustainabilityModuleName = 'sustainability';
export const baerekraftModuleName = 'baerekraft';
export const MiljoprofilModuleName = 'miljo';
const MILJOPROFIL_BYGGNUMMER = 'storedByggnummer';
const MILJOPROFIL_KUNDENUMMER = 'storedKundenummer';

export const SustainabilityRoutes = {
    moduleRoute: () =>
        generateRoute([baerekraftModuleName, SustainabilityModuleName]),
    list: () => generateRoute([baerekraftModuleName, SustainabilityModuleName]),
};

export const MiljoprofilRoutes = {
    moduleRoute: () =>
        generateRoute([baerekraftModuleName, MiljoprofilModuleName]),
    list: (byggNummer?: string) => {
        const route = generateRoute([
            baerekraftModuleName,
            MiljoprofilModuleName,
        ]);

        if (!byggNummer) {
            return route;
        }

        return `${route}?byggnummer=${encodeURIComponent(byggNummer)}`;
    },
};

export const SustainabilityAccess = () =>
    getConfig('WEBAPP_OPPSLAGSTAVLE_ENABLE', false);

export const MiljoprofilAccess = (): boolean =>
    getConfig('WEBAPP_MILJOPROFIL_ENABLE', false);

export const clearMiljoprofilEnvVariables = () => {
    sessionStorage.removeItem(MILJOPROFIL_BYGGNUMMER);
    sessionStorage.removeItem(MILJOPROFIL_KUNDENUMMER);
};

export const SustainabilityMenuItems = [
    new SidebarMenuItem({
        route: MiljoprofilRoutes.list(),
        matchRoute: MiljoprofilRoutes.moduleRoute(),
        icon: IconName.PLANT,
        translation: 'frontPage.miljoprofil.title',
        access: MiljoprofilAccess,
    }),
    new SidebarMenuItem({
        route: SustainabilityRoutes.list(),
        matchRoute: SustainabilityRoutes.moduleRoute(),
        icon: IconName.PLANT,
        endIcon: IconName.EXTERNAL_LINK,
        translation: 'frontPage.sustainability.title',
        access: SustainabilityAccess,
        callback: () =>
            window.open(
                getConfig('WEBAPP_APP_SUSTAINABILITY_LINK', ''),
                '_blank',
            ),
    }),
];
